














































































import Vue from 'vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import MStoreFormSelect from '@/components/shared/MStoreFormSelect.vue';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import { LeaversToolConfigurationsService } from '@/services/LeaversTool/LeaversToolConfigurationsService';
import { EntityType, CabinetReferenceType, LeaversToolConfigurationsModel, LeaversToolConfigurationCreateModel, CabinetModel, ListConfigurationModel, StoreConstants } from '@/types';
import { mapActions } from 'vuex';

export default Vue.extend({
  name: 'LeaversToolConfiguration',
  data() {
    return {
      leaversToolConfiguration: {} as LeaversToolConfigurationCreateModel,
      configurableCabinets: [] as CabinetModel[],
      configurableLists: [] as ListConfigurationModel[],
      isPageLoading: true,
      isLoading: false,
      errorLoadingConfiguration: false,
      configurationExists: true
    };
  },
  methods: {
    ...mapActions(StoreConstants.ApplicationDirty.ModuleName, [StoreConstants.ApplicationDirty.Actions.SetApplicationDirty]),
    async getConfigurationAsync(id: number) {
      await LeaversToolConfigurationsService.getAllAsync()
        .then((result: LeaversToolConfigurationsModel) => {
          this.configurableCabinets = result.configurableCabinets;
          this.configurableLists = result.configurableListConfigurations;
          if (result.configurationExists) {
            this.leaversToolConfiguration.currentCabinetId = result.configurations[0].currentCabinet.id;
            this.leaversToolConfiguration.destinationCabinetId = result.configurations[0].destinationCabinet.id;
            this.leaversToolConfiguration.currentListConfigurationId = result.configurations[0].currentListConfiguration.id;
            this.leaversToolConfiguration.destinationListConfigurationId = result.configurations[0].destinationListConfiguration.id;
          } else {
            this.configurationExists = false;
          }
        })
        .catch((error: any) => {
          this.errorLoadingConfiguration = true;
        });
    },
    handleSubmit(this: any) {
      if (!this.validateDropdowns() || !this.validateSameListSelected() || !this.validateCabinetReferencesMatch()) {
        return;
      }
      this.$validator.validate().then((valid: any) => {
        if (valid) {
          this.$bvModal
            .msgBoxConfirm('Are you sure you want to save this configuration? It cannot be changed once it has been set', {
              title: 'Are you sure?',
              cancelVariant: 'danger'
            })
            .then((result: boolean) => {
              if (result) {
                this.submitConfiguration();
              } else {
                return;
              }
            });
        }
      });
    },
    validateDropdowns(): boolean {
      if (
        this.leaversToolConfiguration.currentCabinetId == null ||
        this.leaversToolConfiguration.destinationCabinetId == null ||
        this.leaversToolConfiguration.currentListConfigurationId == null ||
        this.leaversToolConfiguration.destinationListConfigurationId == null
      ) {
        this.$validator.errors.add({
          field: 'validationErrors',
          msg: 'A value must be selected in every dropdown'
        });
        return false;
      } else {
        this.$validator.errors.remove('validationErrors');
        return true;
      }
    },
    validateSameListSelected(): boolean {
      if (this.leaversToolConfiguration.currentListConfigurationId === this.leaversToolConfiguration.destinationListConfigurationId) {
        this.$validator.errors.add({
          field: 'validationErrors',
          msg: 'The current list and destination list cannot be the same'
        });
        return false;
      } else {
        this.$validator.errors.remove('validationErrors');
        return true;
      }
    },
    validateCabinetReferencesMatch(): boolean {
      const currentCabinet = this.configurableCabinets.find((x) => x.id === this.leaversToolConfiguration.currentCabinetId);

      const destinationCabinet = this.configurableCabinets.find((x) => x.id === this.leaversToolConfiguration.destinationCabinetId);

      let sameReferences: boolean = false;

      if (currentCabinet !== undefined && destinationCabinet !== undefined) {
        const currentCabinetReferences = currentCabinet.references.filter((x) => x.type === CabinetReferenceType.Common);

        const destinationCabinetReferences = destinationCabinet.references.filter((x) => x.type === CabinetReferenceType.Common);

        sameReferences = currentCabinetReferences.length === destinationCabinetReferences.length;

        if (sameReferences) {
          currentCabinetReferences.forEach((currentRef) => {
            if (!destinationCabinetReferences.find((x) => x.referenceDescription.trim().toLowerCase() === currentRef.referenceDescription.trim().toLowerCase())) {
              sameReferences = false;
            }
          });
        }
      }

      if (!sameReferences) {
        this.$validator.errors.add({
          field: 'validationErrors',
          msg: 'The common references for the current cabinet and the destination cabinet must be the same'
        });
      } else {
        this.$validator.errors.remove('validationErrors');
      }

      return sameReferences;
    },
    submitConfiguration(this: any) {
      this.isLoading = true;
      LeaversToolConfigurationsService.createAsync(this.leaversToolConfiguration)
        .then((response: any) => {
          SnotifyConfiguration.showSuccess('Configuration added successfully.');
          this.configurationExists = true;
          this.$validator.errors.remove('serverValidationErrors');
          this[StoreConstants.ApplicationDirty.Actions.SetApplicationDirty](false);
          this.isLoading = false;
          this.$router.push({ name: 'leaverRules' });
        })
        .catch((error: any) => {
          this.$validator.errors.add({
            field: 'serverValidationErrors',
            msg: error.notification
          });
          this.isLoading = false;
        });
    }
  },
  components: {
    LoadingSpinner,
    MStoreFormSelect
  },
  async mounted(this: any) {
    try {
      await this.getConfigurationAsync();
    } finally {
      this.isPageLoading = false;
    }
  }
});
